// extracted by mini-css-extract-plugin
export default {"grouper":"MainFeed_grouper__mpZco"};